export const fontWeights = {
    regular: 400,
    medium: 500,
    bold: 700,
};

export const fontSizes = {
    h6: "8px",
    h5: "10px",
    h4: "12px",
    h3: "14px",
    h2: "18px",
    h1: "24px",
};